import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';

const RegistrationPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showSecurityAnswer, setShowSecurityAnswer] = useState(false);

  // State for all form fields
  const [formData, setFormData] = useState({
    // Personal Details
    candidateName: '',
    fatherName: '',
    motherName: '',
    dobDay: '0',
    dobMonth: '0',
    dobYear: '0',
    gender: '0',

    // Confirm Personal Details
    confirmCandidateName: '',
    confirmFatherName: '',
    confirmMotherName: '',
    confirmDobDay: '0',
    confirmDobMonth: '0',
    confirmDobYear: '0',
    confirmGender: '0',

    // Present Address
    presAddress: '',
    presSubLocality: '',
    presLocality: '',
    presCountry: '0',
    presState: '0',
    presDistrict: '0',
    presPincode: '',

    // Electronic Communication Address
    email: '',
    confirmEmail: '',
    mobile: '',
    confirmMobile: '',
    altMobile: '',

    // Permanent Address
    sameAsPresent: false,
    permAddress: '',
    permSubLocality: '',
    permLocality: '',
    permCountry: '0',
    permState: '0',
    permDistrict: '0',
    permPincode: '',

    // Password & Security
    password: '',
    confirmPassword: '',
    securityQuestion: '0',
    securityAnswer: '',

    // Captcha
    captcha: ''
  });

  // Countries list
  const countries = [
    { code: '0', name: '--Select--' },
    { code: 'IN', name: 'India' },
    { code: 'AD', name: 'Andorra' },
    { code: 'AE', name: 'United Arab Emirates' },
    { code: 'AF', name: 'Afghanistan' },
    { code: 'AG', name: 'Antigua and Barbuda' },
    { code: 'AI', name: 'Anguilla' },
    { code: 'AL', name: 'Albania' },
    { code: 'AM', name: 'Armenia' },
    { code: 'AO', name: 'Angola' },
    { code: 'AQ', name: 'Antarctica' },
    { code: 'AR', name: 'Argentina' },
    { code: 'AS', name: 'American Samoa' },
    { code: 'AT', name: 'Austria' },
    { code: 'AU', name: 'Australia' },
    { code: 'AW', name: 'Aruba' },
    { code: 'AZ', name: 'Azerbaijan' },
    { code: 'BA', name: 'Bosnia and Herzegovina' },
    { code: 'BB', name: 'Barbados' },
    { code: 'BD', name: 'Bangladesh' },
    { code: 'BE', name: 'Belgium' },
    { code: 'BF', name: 'Burkina Faso' },
    { code: 'BG', name: 'Bulgaria' },
    { code: 'BH', name: 'Bahrain' },
    { code: 'BI', name: 'Burundi' },
    { code: 'BJ', name: 'Benin' },
    { code: 'BM', name: 'Bermuda' },
    { code: 'BN', name: 'Brunei Darussalam' },
    { code: 'BO', name: 'Bolivia' },
    { code: 'BR', name: 'Brazil' },
    { code: 'BS', name: 'Bahamas' },
    { code: 'BT', name: 'Bhutan' },
    { code: 'BW', name: 'Botswana' },
    { code: 'BY', name: 'Belarus' },
    { code: 'BZ', name: 'Belize' },
    { code: 'CA', name: 'Canada' },
    { code: 'CD', name: 'Congo, Democratic Republic of' },
    { code: 'CF', name: 'Central African Republic' },
    { code: 'CG', name: 'Congo' },
    { code: 'CH', name: 'Switzerland' },
    { code: 'CL', name: 'Chile' },
    { code: 'CM', name: 'Cameroon' },
    { code: 'CN', name: 'China' },
    { code: 'CO', name: 'Colombia' },
    { code: 'CR', name: 'Costa Rica' },
    { code: 'CU', name: 'Cuba' },
    { code: 'CY', name: 'Cyprus' },
    { code: 'CZ', name: 'Czech Republic' },
    { code: 'DE', name: 'Germany' },
    { code: 'DJ', name: 'Djibouti' },
    { code: 'DK', name: 'Denmark' },
    { code: 'DO', name: 'Dominican Republic' },
    { code: 'DZ', name: 'Algeria' },
    { code: 'EC', name: 'Ecuador' },
    { code: 'EE', name: 'Estonia' },
    { code: 'EG', name: 'Egypt' },
    { code: 'ES', name: 'Spain' },
    { code: 'ET', name: 'Ethiopia' },
    { code: 'FI', name: 'Finland' },
    { code: 'FJ', name: 'Fiji' },
    { code: 'FR', name: 'France' },
    { code: 'GA', name: 'Gabon' },
    { code: 'GB', name: 'United Kingdom' },
    { code: 'GD', name: 'Grenada' },
    { code: 'GE', name: 'Georgia' },
    { code: 'GH', name: 'Ghana' },
    { code: 'GR', name: 'Greece' },
    { code: 'GT', name: 'Guatemala' },
    { code: 'GY', name: 'Guyana' },
    { code: 'HK', name: 'Hong Kong' },
    { code: 'HN', name: 'Honduras' },
    { code: 'HR', name: 'Croatia' },
    { code: 'HT', name: 'Haiti' },
    { code: 'HU', name: 'Hungary' },
    { code: 'ID', name: 'Indonesia' },
    { code: 'IE', name: 'Ireland' },
    { code: 'IL', name: 'Israel' },
    { code: 'IQ', name: 'Iraq' },
    { code: 'IR', name: 'Iran' },
    { code: 'IS', name: 'Iceland' },
    { code: 'IT', name: 'Italy' },
    { code: 'JM', name: 'Jamaica' },
    { code: 'JO', name: 'Jordan' },
    { code: 'JP', name: 'Japan' },
    { code: 'KE', name: 'Kenya' },
    { code: 'KG', name: 'Kyrgyzstan' },
    { code: 'KH', name: 'Cambodia' },
    { code: 'KP', name: 'North Korea' },
    { code: 'KR', name: 'South Korea' },
    { code: 'KW', name: 'Kuwait' },
    { code: 'KZ', name: 'Kazakhstan' },
    { code: 'LA', name: "Lao People's Democratic Republic" },
    { code: 'LB', name: 'Lebanon' },
    { code: 'LK', name: 'Sri Lanka' },
    { code: 'LR', name: 'Liberia' },
    { code: 'LT', name: 'Lithuania' },
    { code: 'LU', name: 'Luxembourg' },
    { code: 'LV', name: 'Latvia' },
    { code: 'LY', name: 'Libya' },
    { code: 'MA', name: 'Morocco' },
    { code: 'MC', name: 'Monaco' },
    { code: 'MD', name: 'Moldova' },
    { code: 'ME', name: 'Montenegro' },
    { code: 'MG', name: 'Madagascar' },
    { code: 'MK', name: 'Macedonia' },
    { code: 'ML', name: 'Mali' },
    { code: 'MM', name: 'Myanmar' },
    { code: 'MN', name: 'Mongolia' },
    { code: 'MO', name: 'Macau' },
    { code: 'MR', name: 'Mauritania' },
    { code: 'MT', name: 'Malta' },
    { code: 'MU', name: 'Mauritius' },
    { code: 'MV', name: 'Maldives' },
    { code: 'MW', name: 'Malawi' },
    { code: 'MX', name: 'Mexico' },
    { code: 'MY', name: 'Malaysia' },
    { code: 'MZ', name: 'Mozambique' },
    { code: 'NA', name: 'Namibia' },
    { code: 'NE', name: 'Niger' },
    { code: 'NG', name: 'Nigeria' },
    { code: 'NI', name: 'Nicaragua' },
    { code: 'NL', name: 'The Netherlands' },
    { code: 'NO', name: 'Norway' },
    { code: 'NP', name: 'Nepal' },
    { code: 'NZ', name: 'New Zealand' },
    { code: 'OM', name: 'Oman' },
    { code: 'PA', name: 'Panama' },
    { code: 'PE', name: 'Peru' },
    { code: 'PG', name: 'Papua New Guinea' },
    { code: 'PH', name: 'Philippines' },
    { code: 'PK', name: 'Pakistan' },
    { code: 'PL', name: 'Poland' },
    { code: 'PT', name: 'Portugal' },
    { code: 'PY', name: 'Paraguay' },
    { code: 'QA', name: 'Qatar' },
    { code: 'RO', name: 'Romania' },
    { code: 'RS', name: 'Serbia' },
    { code: 'RU', name: 'Russian Federation' },
    { code: 'RW', name: 'Rwanda' },
    { code: 'SA', name: 'Saudi Arabia' },
    { code: 'SD', name: 'Sudan' },
    { code: 'SE', name: 'Sweden' },
    { code: 'SG', name: 'Singapore' },
    { code: 'SI', name: 'Slovenia' },
    { code: 'SK', name: 'Slovakia' },
    { code: 'SL', name: 'Sierra Leone' },
    { code: 'SN', name: 'Senegal' },
    { code: 'SO', name: 'Somalia' },
    { code: 'SS', name: 'South Sudan' },
    { code: 'SY', name: 'Syria' },
    { code: 'TH', name: 'Thailand' },
    { code: 'TJ', name: 'Tajikistan' },
    { code: 'TN', name: 'Tunisia' },
    { code: 'TR', name: 'Turkey' },
    { code: 'TT', name: 'Trinidad and Tobago' },
    { code: 'TW', name: 'Taiwan' },
    { code: 'TZ', name: 'Tanzania' },
    { code: 'UA', name: 'Ukraine' },
    { code: 'UG', name: 'Uganda' },
    { code: 'US', name: 'United States' },
    { code: 'UY', name: 'Uruguay' },
    { code: 'UZ', name: 'Uzbekistan' },
    { code: 'VE', name: 'Venezuela' },
    { code: 'VN', name: 'Vietnam' },
    { code: 'YE', name: 'Yemen' },
    { code: 'ZA', name: 'South Africa' },
    { code: 'ZM', name: 'Zambia' },
    { code: 'ZW', name: 'Zimbabwe' }
  ];

  // Indian States list
  const states = [
    { code: '0', name: '--Select--' },
    { code: '01', name: 'ANDAMAN AND NICOBAR ISLANDS' },
    { code: '02', name: 'ANDHRA PRADESH' },
    { code: '03', name: 'ARUNACHAL PRADESH' },
    { code: '04', name: 'ASSAM' },
    { code: '05', name: 'BIHAR' },
    { code: '06', name: 'CHANDIGARH' },
    { code: '07', name: 'CHHATTISGARH' },
    { code: '08', name: 'DADRA AND NAGAR HAVELI' },
    { code: '09', name: 'DAMAN AND DIU' },
    { code: '10', name: 'DELHI' },
    { code: '11', name: 'GOA' },
    { code: '12', name: 'GUJARAT' },
    { code: '13', name: 'HARYANA' },
    { code: '14', name: 'HIMACHAL PRADESH' },
    { code: '15', name: 'JAMMU AND KASHMIR' },
    { code: '16', name: 'JHARKHAND' },
    { code: '17', name: 'KARNATAKA' },
    { code: '18', name: 'KERALA' },
    { code: '37', name: 'LADAKH' },
    { code: '19', name: 'LAKSHADWEEP' },
    { code: '20', name: 'MADHYA PRADESH' },
    { code: '21', name: 'MAHARASHTRA' },
    { code: '22', name: 'MANIPUR' },
    { code: '23', name: 'MEGHALAYA' },
    { code: '24', name: 'MIZORAM' },
    { code: '25', name: 'NAGALAND' },
    { code: '26', name: 'ODISHA' },
    { code: '27', name: 'PUDUCHERRY' },
    { code: '28', name: 'PUNJAB' },
    { code: '29', name: 'RAJASTHAN' },
    { code: '30', name: 'SIKKIM' },
    { code: '31', name: 'TAMIL NADU' },
    { code: '36', name: 'TELANGANA' },
    { code: '32', name: 'TRIPURA' },
    { code: '33', name: 'UTTAR PRADESH' },
    { code: '34', name: 'UTTARAKHAND' },
    { code: '35', name: 'WEST BENGAL' }
  ];

  // Security Questions
  const securityQuestions = [
    { code: '0', name: '--Select--' },
    { code: '01', name: 'Which is the website you frequently visit ?' },
    { code: '02', name: 'What is the name of your first school?' },
    { code: '03', name: 'What is your favourite colour ?' },
    { code: '04', name: 'What is the registration number of your first vehicle ?' },
    { code: '05', name: 'Which is your favourite book ?' },
    { code: '06', name: 'What is your favourite sport ?' },
    { code: '07', name: 'What is your place of birth ?' }
  ];
  // New State for Lookups
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [permDistrictList, setPermDistrictList] = useState([]); // For permanent address if different

  // 1. Fetch States on Component Mount
  useEffect(() => {
      const fetchStates = async () => {
          try {
              const res = await api.get('/mock-cuet/states');
              if(res.data.success) {
                  setStateList(res.data.data);
              }
          } catch(err) { console.error("Error fetching states", err); }
      };
      fetchStates();
  }, []);
// 2. Fetch Districts when Present State Changes
  useEffect(() => {
      if(formData.presState && formData.presState !== '0') {
          const fetchDistricts = async () => {
              try {
                  const res = await api.get(`/mock-cuet/districts/${formData.presState}`);
                  if(res.data.success) {
                      setDistrictList(res.data.data);
                  }
              } catch(err) { console.error("Error fetching districts", err); }
          };
          fetchDistricts();
      } else {
          setDistrictList([]); // Reset if state cleared
      }
  }, [formData.presState]);
// 3. Fetch Districts when Permanent State Changes (if not same as present)
  useEffect(() => {
      if(!formData.sameAsPresent && formData.permState && formData.permState !== '0') {
           const fetchPermDistricts = async () => {
              try {
                  const res = await api.get(`/mock-cuet/districts/${formData.permState}`);
                  if(res.data.success) {
                      setPermDistrictList(res.data.data);
                  }
              } catch(err) { console.error("Error fetching perm districts", err); }
          };
          fetchPermDistricts();
      }
  }, [formData.permState, formData.sameAsPresent]);
  // Months list
  const months = [
    { code: '0', name: '--Month--' },
    { code: '01', name: 'January (01)' },
    { code: '02', name: 'February (02)' },
    { code: '03', name: 'March (03)' },
    { code: '04', name: 'April (04)' },
    { code: '05', name: 'May (05)' },
    { code: '06', name: 'June (06)' },
    { code: '07', name: 'July (07)' },
    { code: '08', name: 'August (08)' },
    { code: '09', name: 'September (09)' },
    { code: '10', name: 'October (10)' },
    { code: '11', name: 'November (11)' },
    { code: '12', name: 'December (12)' }
  ];
  
  // Generate days 01-31
  const days = [{ code: '0', name: '--Day--' }];
  for (let i = 1; i <= 31; i++) {
    const padded = i.toString().padStart(2, '0');
    days.push({ code: padded, name: padded });
  }

  // Generate years 1960-2011 (descending)
  const years = [{ code: '0', name: '--Year--' }];
  for (let i = 2011; i >= 1960; i--) {
    years.push({ code: i.toString(), name: i.toString() });
  }

  // Districts - placeholder, would typically be loaded based on state selection
  const [presDistricts, setPresDistricts] = useState([{ code: '0', name: '--Select--' }]);
  const [permDistricts, setPermDistricts] = useState([{ code: '0', name: '--Select--' }]);

  // Handle Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => {
      const newData = { ...prev, [name]: value };

      // Auto-sync permanent address if checkbox is checked
      if (newData.sameAsPresent && name.startsWith('pres')) {
        const permKey = name.replace('pres', 'perm');
        if (newData.hasOwnProperty(permKey)) {
          newData[permKey] = value;
        }
      }
      return newData;
    });
  };

  // Handle Checkbox "Same as Present"
  const handleCheckbox = (e) => {
    const checked = e.target.checked;
    setFormData(prev => ({
      ...prev,
      sameAsPresent: checked,
      permAddress: checked ? prev.presAddress : prev.permAddress,
      permSubLocality: checked ? prev.presSubLocality : prev.permSubLocality,
      permLocality: checked ? prev.presLocality : prev.permLocality,
      permCountry: checked ? prev.presCountry : prev.permCountry,
      permState: checked ? prev.presState : prev.permState,
      permDistrict: checked ? prev.presDistrict : prev.permDistrict,
      permPincode: checked ? prev.presPincode : prev.permPincode,
    }));
  };

  // Submit Handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic Client Validation
    if (formData.candidateName !== formData.confirmCandidateName) {
      alert("Candidate's Name and Confirm Candidate Name should be the same.");
      return;
    }
    if (formData.fatherName !== formData.confirmFatherName) {
      alert("Father Name and Confirm Father Name should be the same.");
      return;
    }
    if (formData.motherName !== formData.confirmMotherName) {
      alert("Mother Name and Confirm Mother Name should be the same.");
      return;
    }
    if (formData.dobDay !== formData.confirmDobDay || 
        formData.dobMonth !== formData.confirmDobMonth || 
        formData.dobYear !== formData.confirmDobYear) {
      alert("Date of Birth and Confirm Date of Birth should be the same.");
      return;
    }
    if (formData.gender !== formData.confirmGender) {
      alert("Gender and Confirm Gender should be the same.");
      return;
    }
    if (formData.password !== formData.confirmPassword) {
      alert("Password & Confirm Password must be same");
      return;
    }
    if (formData.email !== formData.confirmEmail) {
      alert("Email Address and Confirm Email Address should be the same.");
      return;
    }
    if (formData.mobile !== formData.confirmMobile) {
      alert("Mobile Number and Confirm Mobile Number should be the same.");
      return;
    }
    if (formData.dobDay === '0' || formData.dobMonth === '0' || formData.dobYear === '0') {
      alert("Please select a valid Date of Birth");
      return;
    }
    if (formData.gender === '0') {
      alert("Please select Gender");
      return;
    }
    if (formData.presCountry === '0') {
      alert("Please select Country for Present Address");
      return;
    }
    if (formData.presCountry === 'IN' && formData.presState === '0') {
      alert("Please select State for Present Address");
      return;
    }
    if (formData.securityQuestion === '0') {
      alert("Please select Security Question");
      return;
    }

    // Password validation
    const passwordRegex = /^(?=.{8,13})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\W).*$/;
    if (!passwordRegex.test(formData.password)) {
      alert('Your password must satisfy the following. \n\n* Password should be 8 to 13 character long. \n* Password should have at least one Upper case alphabet.\n* Password should have at least one Lower case alphabet. \n* Password should have at least one numeric value. \n* Password should have at least one special characters eg.!@#$%^&*-');
      return;
    }

    setLoading(true);
    try {
      // Construct standard DOB format for DB
      const dobDate = `${formData.dobYear}-${formData.dobMonth}-${formData.dobDay}`;

      const payload = {
        ...formData,
        dob: dobDate
      };

      const res = await api.post('/mock-cuet/register', payload);
      if (res.data.success) {
        // Navigate to success page showing credentials
        navigate('/services/counselling/success', {
          state: { creds: res.data.data }
        });
      }
    } catch (err) {
      console.error(err);
      alert("Registration failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container contentmid">
      <div className="appstatus" style={{ paddingTop: '0px', marginTop: '0px' }}>
        <div>

          {/* ================== PERSONAL DETAILS SECTION ================== */}
          <div>
            <h4>
              <span>व्यक्तिगत विवरण(Personal Details)</span>
              <br /><br />
              <span className="bg-warning text-danger decrease_font" style={{ fontSize: '13px', padding: '5px' }}>
                कृपया मान्यता प्राप्त स्कूल परीक्षा बोर्ड द्वारा जारी कक्षा 10वीं उत्तीर्ण प्रमाणपत्र/मार्कशीट पर मुद्रित विवरण भरें। (Please fill details as printed on Class 10th Passing Certificate / Marksheet issued by recognized School Examination Board.)
              </span>
            </h4>

            <div className="form-horizontal formLabel">
              {/* Candidate Name */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>अभ्यर्थी का नाम (Candidate's Name)</span>
                </label>
                <div className="col-sm-4">
                  <input type="text" name="candidateName" className="form-control" maxLength="80" value={formData.candidateName} onChange={handleChange} required />
                </div>
              </div>

              {/* Father Name */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>पिता / अभिभावक का नाम (Father's / Guardian's Name)</span>
                </label>
                <div className="col-sm-4">
                  <input type="text" name="fatherName" className="form-control" maxLength="80" value={formData.fatherName} onChange={handleChange} required />
                </div>
              </div>

              {/* Mother Name */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>माता / अभिभावक का नाम (Mother's / Guardian's Name)</span>
                </label>
                <div className="col-sm-4">
                  <input type="text" name="motherName" className="form-control" maxLength="80" value={formData.motherName} onChange={handleChange} required />
                </div>
              </div>

              {/* Date of Birth */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>अभ्यर्थी की जन्म तिथि (Candidate's Date of Birth)</span>
                </label>
                <div className="col-sm-2">
                  <select name="dobDay" className="form-control" value={formData.dobDay} onChange={handleChange}>
                    {days.map((d) => <option key={d.code} value={d.code}>{d.name}</option>)}
                  </select>
                </div>
                <div className="col-sm-2">
                  <select name="dobMonth" className="form-control" value={formData.dobMonth} onChange={handleChange}>
                    {months.map((m) => <option key={m.code} value={m.code}>{m.name}</option>)}
                  </select>
                </div>
                <div className="col-sm-2">
                  <select name="dobYear" className="form-control" value={formData.dobYear} onChange={handleChange}>
                    {years.map((y) => <option key={y.code} value={y.code}>{y.name}</option>)}
                  </select>
                </div>
              </div>

              {/* Gender */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>लिंग (Gender)</span>
                </label>
                <div className="col-sm-4">
                  <select name="gender" className="form-control" value={formData.gender} onChange={handleChange} required>
                    <option value="0">--Select--</option>
                    <option value="01">Male</option>
                    <option value="02">Female</option>
                    <option value="04">Third Gender</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* ================== CONFIRM PERSONAL DETAILS SECTION ================== */}
          <div>
            <h4>
              <span>व्यक्तिगत विवरण की पुष्टि करें (Confirm Personal Details)</span>
            </h4>

            <div className="form-horizontal formLabel">
              {/* Confirm Candidate Name */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>अभ्यर्थी के नाम की पुष्टि करें (Confirm Candidate Name)</span>
                </label>
                <div className="col-sm-4">
                  <input 
                    type="text" 
                    name="confirmCandidateName" 
                    className="form-control" 
                    maxLength="80" 
                    value={formData.confirmCandidateName} 
                    onChange={handleChange} 
                    onCopy={(e) => e.preventDefault()} 
                    onPaste={(e) => e.preventDefault()} 
                    onCut={(e) => e.preventDefault()} 
                    required 
                  />
                </div>
              </div>

              {/* Confirm Father Name */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>पिता / अभिभावक के नाम की पुष्टि करें (Confirm Father / Guardian Name)</span>
                </label>
                <div className="col-sm-4">
                  <input 
                    type="text" 
                    name="confirmFatherName" 
                    className="form-control" 
                    maxLength="80" 
                    value={formData.confirmFatherName} 
                    onChange={handleChange} 
                    onCopy={(e) => e.preventDefault()} 
                    onPaste={(e) => e.preventDefault()} 
                    onCut={(e) => e.preventDefault()} 
                    required 
                  />
                </div>
              </div>

              {/* Confirm Mother Name */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>माता / अभिभावक के नाम की पुष्टि करें (Confirm Mother / Guardian Name)</span>
                </label>
                <div className="col-sm-4">
                  <input 
                    type="text" 
                    name="confirmMotherName" 
                    className="form-control" 
                    maxLength="80" 
                    value={formData.confirmMotherName} 
                    onChange={handleChange} 
                    onCopy={(e) => e.preventDefault()} 
                    onPaste={(e) => e.preventDefault()} 
                    onCut={(e) => e.preventDefault()} 
                    required 
                  />
                </div>
              </div>

              {/* Confirm Date of Birth */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>जन्मतिथि की पुष्टि करें (Confirm Date of Birth)</span>
                </label>
                <div className="col-sm-2">
                  <select name="confirmDobDay" className="form-control" value={formData.confirmDobDay} onChange={handleChange}>
                    {days.map((d) => <option key={d.code} value={d.code}>{d.name}</option>)}
                  </select>
                </div>
                <div className="col-sm-2">
                  <select name="confirmDobMonth" className="form-control" value={formData.confirmDobMonth} onChange={handleChange}>
                    {months.map((m) => <option key={m.code} value={m.code}>{m.name}</option>)}
                  </select>
                </div>
                <div className="col-sm-2">
                  <select name="confirmDobYear" className="form-control" value={formData.confirmDobYear} onChange={handleChange}>
                    {years.map((y) => <option key={y.code} value={y.code}>{y.name}</option>)}
                  </select>
                </div>
              </div>

              {/* Confirm Gender */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>लिंग की पुष्टि करें (Confirm Gender)</span>
                </label>
                <div className="col-sm-4">
                  <select name="confirmGender" className="form-control" value={formData.confirmGender} onChange={handleChange} required>
                    <option value="0">--Select--</option>
                    <option value="01">Male</option>
                    <option value="02">Female</option>
                    <option value="04">Third Gender</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <hr style={{ borderTop: '1px solid #ccc' }} />

          {/* ================== PRESENT ADDRESS ================== */}
          <div>
            <h4>
              <span>वर्तमान पता (Present Address)</span>
            </h4>
            <p style={{ fontStyle: 'italic' }}>
              The examination city options will be generated based on the candidate's permanent and present addresses. 
              Accordingly, the candidate may be allotted an examination centre at either location, depending on the choices selected.
            </p>

            <div className="form-horizontal formLabel">
              {/* Address */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>पता (Premises No/ Name)</span>
                </label>
                <div className="col-sm-4">
                  <input type="text" name="presAddress" className="form-control" maxLength="100" value={formData.presAddress} onChange={handleChange} required />
                </div>
              </div>

              {/* Sub Locality */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>उप-स्थानीयता (Sub-Locality)</span>(Optional)
                </label>
                <div className="col-sm-4">
                  <input type="text" name="presSubLocality" className="form-control" maxLength="100" value={formData.presSubLocality} onChange={handleChange} />
                </div>
              </div>

              {/* Locality */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>स्थानीयता (Locality)</span>
                </label>
                <div className="col-sm-4">
                  <input type="text" name="presLocality" className="form-control" maxLength="50" value={formData.presLocality} onChange={handleChange} required />
                </div>
              </div>

              {/* Country */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>देश (Country)</span>
                </label>
                <div className="col-sm-4">
                  <select name="presCountry" className="form-control" value={formData.presCountry} onChange={handleChange} required>
                    {countries.map((c) => <option key={c.code} value={c.code}>{c.name}</option>)}
                  </select>
                </div>
              </div>

              {/* State (only for India) */}
              {formData.presCountry === 'IN' && (
                <div className="form-group">
                  <label className="control-label col-sm-4">
                    <span>राज्य (State)</span>
                  </label>
                  <div className="col-sm-4">
                    <select name="presState" className="form-control" value={formData.presState} onChange={handleChange} required>
                      {states.map((s) => <option key={s.code} value={s.code}>{s.name}</option>)}
                    </select>
                  </div>
                </div>
              )}

              {/* District (only for India) */}
              {formData.presCountry === 'IN' && (
                <div className="form-group">
                  <label className="control-label col-sm-4">
                    <span>जिला (District)</span>
                  </label>
                  <div className="col-sm-4">
                    <select name="presDistrict" className="form-control" value={formData.presDistrict} onChange={handleChange} required>
                        <option value="0">--Select District--</option>
                        {districtList.map((dist) => (
                            <option key={dist.district_code} value={dist.district_code}>
                                {dist.district_name}
                            </option>
                        ))}
                    </select>
                  </div>
                </div>
              )}

              {/* Pincode */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>पिन कोड (PIN Code)</span>
                </label>
                <div className="col-sm-4">
                  <input type="text" name="presPincode" className="form-control" maxLength="15" value={formData.presPincode} onChange={handleChange} required />
                </div>
              </div>
            </div>

            {/* Electronic Communication Address */}
            <h4>इलेक्ट्रॉनिक संचार पता (Electronic Communication Address)</h4>
            <p style={{ fontStyle: 'italic' }}>Please enter correct Email Id and Mobile Number as OTP will be shared on these for verification.</p>

            <div className="form-horizontal formLabel">
              {/* Email */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>ईमेल पता (Email Address)</span>
                </label>
                <div className="col-sm-4">
                  <input 
                    type="email" 
                    name="email" 
                    className="form-control" 
                    maxLength="50" 
                    value={formData.email} 
                    onChange={handleChange} 
                    onCopy={(e) => e.preventDefault()} 
                    onPaste={(e) => e.preventDefault()} 
                    onCut={(e) => e.preventDefault()} 
                    required 
                  />
                </div>
              </div>

              {/* Confirm Email */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>Confirm Email Address</span>
                </label>
                <div className="col-sm-4">
                  <input 
                    type="email" 
                    name="confirmEmail" 
                    className="form-control" 
                    maxLength="50" 
                    value={formData.confirmEmail} 
                    onChange={handleChange} 
                    onCopy={(e) => e.preventDefault()} 
                    onPaste={(e) => e.preventDefault()} 
                    onCut={(e) => e.preventDefault()} 
                    required 
                  />
                </div>
              </div>

              {/* Mobile */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>मोबाइल नंबर (Mobile Number)</span>
                </label>
                <div className="col-sm-1">
                  <span className="form-control" style={{ fontWeight: 'bold' }}>91</span>
                </div>
                <div className="col-sm-3">
                  <input 
                    type="text" 
                    name="mobile" 
                    className="form-control" 
                    maxLength="10" 
                    value={formData.mobile} 
                    onChange={handleChange} 
                    onCopy={(e) => e.preventDefault()} 
                    onPaste={(e) => e.preventDefault()} 
                    onCut={(e) => e.preventDefault()} 
                    required 
                  />
                </div>
              </div>

              {/* Confirm Mobile */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>Confirm Mobile Number</span>
                </label>
                <div className="col-sm-1">
                  <span className="form-control" style={{ fontWeight: 'bold' }}>91</span>
                </div>
                <div className="col-sm-3">
                  <input 
                    type="text" 
                    name="confirmMobile" 
                    className="form-control" 
                    maxLength="10" 
                    value={formData.confirmMobile} 
                    onChange={handleChange} 
                    onCopy={(e) => e.preventDefault()} 
                    onPaste={(e) => e.preventDefault()} 
                    onCut={(e) => e.preventDefault()} 
                    required 
                  />
                </div>
              </div>

              {/* Alternate Contact */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>वैकल्पिक संपर्क सूत्र (Alternate Contact No.)</span> (Optional)
                </label>
                <div className="col-sm-4">
                  <input type="text" name="altMobile" className="form-control" maxLength="20" value={formData.altMobile} onChange={handleChange} />
                </div>
              </div>
            </div>
          </div>

          <hr style={{ borderTop: '1px solid #ccc' }} />

          {/* ================== PERMANENT ADDRESS ================== */}
          <div>
            <h4>
              <span>स्थायी पता (Permanent Address)</span>
            </h4>

            <table width="100%" className="table table-bordered table-condensed text-danger bg-warning" style={{ marginBottom: '15px' }}>
              <tbody>
                <tr>
                  <td>
                    <div className="checkbox" style={{ margin: '5px 15px' }}>
                      <label>
                        <input type="checkbox" checked={formData.sameAsPresent} onChange={handleCheckbox} /> Same As Present Address
                      </label>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            {!formData.sameAsPresent && (
              <>
                <p style={{ fontStyle: 'italic' }}>
                  The examination city options will be generated based on the candidate's permanent and present addresses. 
                  Accordingly, the candidate may be allotted an examination centre at either location, depending on the choices selected.
                </p>

                <div className="form-horizontal formLabel">
                  {/* Address */}
                  <div className="form-group">
                    <label className="control-label col-sm-4">
                      <span>पता (Premises No/ Name)</span>
                    </label>
                    <div className="col-sm-4">
                      <input type="text" name="permAddress" className="form-control" maxLength="100" value={formData.permAddress} onChange={handleChange} disabled={formData.sameAsPresent} />
                    </div>
                  </div>

                  {/* Sub Locality */}
                  <div className="form-group">
                    <label className="control-label col-sm-4">
                      <span>उप-स्थानीयता (Sub-Locality)</span>(Optional):
                    </label>
                    <div className="col-sm-4">
                      <input type="text" name="permSubLocality" className="form-control" maxLength="100" value={formData.permSubLocality} onChange={handleChange} disabled={formData.sameAsPresent} />
                    </div>
                  </div>

                  {/* Locality */}
                  <div className="form-group">
                    <label className="control-label col-sm-4">
                      <span>स्थानीयता (Locality)</span>
                    </label>
                    <div className="col-sm-4">
                      <input type="text" name="permLocality" className="form-control" maxLength="50" value={formData.permLocality} onChange={handleChange} disabled={formData.sameAsPresent} />
                    </div>
                  </div>

                  {/* Country */}
                  <div className="form-group">
                    <label className="control-label col-sm-4">
                      <span>देश (Country)</span>
                    </label>
                    <div className="col-sm-4">
                      <select name="permCountry" className="form-control" value={formData.permCountry} onChange={handleChange} disabled={formData.sameAsPresent}>
                        {countries.map((c) => <option key={c.code} value={c.code}>{c.name}</option>)}
                      </select>
                    </div>
                  </div>

                  {/* State (only for India) */}
                  {formData.permCountry === 'IN' && (
                    <div className="form-group">
                      <label className="control-label col-sm-4">
                        <span>राज्य (State)</span>
                      </label>
                      <div className="col-sm-4">
                        <select name="permState" className="form-control" value={formData.permState} onChange={handleChange} disabled={formData.sameAsPresent}>
                          {states.map((s) => <option key={s.code} value={s.code}>{s.name}</option>)}
                        </select>
                      </div>
                    </div>
                  )}

                  {/* District (only for India) */}
                  {formData.permCountry === 'IN' && (
                    <div className="form-group">
                      <label className="control-label col-sm-4">
                        <span>जिला (District)</span>
                      </label>
                      <div className="col-sm-4">
                        <select name="permDistrict" className="form-control" value={formData.permDistrict} onChange={handleChange} disabled={formData.sameAsPresent}>
                            <option value="0">--Select District--</option>
                          {/* {permDistricts.map((d) => <option key={d.code} value={d.code}>{d.name}</option>)} */}
                          {permDistrictList.map((dist) => (
                            <option key={dist.district_code} value={dist.district_code}>
                                {dist.district_name}
                            </option>
                        ))}
                        </select>
                      </div>
                    </div>
                  )}

                  {/* Pincode */}
                  <div className="form-group">
                    <label className="control-label col-sm-4">
                      <span>पिन कोड (PIN Code)</span>
                    </label>
                    <div className="col-sm-4">
                      <input type="text" name="permPincode" className="form-control" maxLength="6" value={formData.permPincode} onChange={handleChange} disabled={formData.sameAsPresent} />
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          <hr style={{ borderTop: '1px solid #ccc' }} />

          {/* ================== CHOOSE PASSWORD ================== */}
          <div>
            <h4>Choose Password</h4>
            <div className="form-horizontal formLabel">
              {/* Password */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>कुंजिका (Password)</span>
                </label>
                <div className="col-sm-4">
                  <div className="input-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      className="form-control"
                      value={formData.password}
                      onChange={handleChange}
                      onCopy={(e) => e.preventDefault()}
                      onPaste={(e) => e.preventDefault()}
                      onCut={(e) => e.preventDefault()}
                      required
                    />
                    <span className="input-group-addon" onClick={() => setShowPassword(!showPassword)} style={{ cursor: 'pointer' }}>
                      <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                    </span>
                  </div>
                  <small className="text-muted">
                    Password must be 8-13 characters with at least one uppercase, one lowercase, one number, and one special character (!@#$%^&*-)
                  </small>
                </div>
              </div>

              {/* Confirm Password */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>कुंजिका की पुष्टि कीजिये (Confirm Password)</span>
                </label>
                <div className="col-sm-4">
                  <div className="input-group">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      name="confirmPassword"
                      className="form-control"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      onCopy={(e) => e.preventDefault()}
                      onPaste={(e) => e.preventDefault()}
                      onCut={(e) => e.preventDefault()}
                      required
                    />
                    <span className="input-group-addon" onClick={() => setShowConfirmPassword(!showConfirmPassword)} style={{ cursor: 'pointer' }}>
                      <i className={`fa ${showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                    </span>
                  </div>
                </div>
              </div>

              {/* Security Question */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>सुरक्षा प्रश्न (Security Question)</span>
                </label>
                <div className="col-sm-4">
                  <select name="securityQuestion" className="form-control" value={formData.securityQuestion} onChange={handleChange} required>
                    {securityQuestions.map((q) => <option key={q.code} value={q.code}>{q.name}</option>)}
                  </select>
                </div>
              </div>

              {/* Security Answer */}
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <span>सुरक्षा जवाब (Security Answer)</span>
                </label>
                <div className="col-sm-4">
                  <div className="input-group">
                    <input
                      type={showSecurityAnswer ? "text" : "password"}
                      name="securityAnswer"
                      className="form-control"
                      value={formData.securityAnswer}
                      onChange={handleChange}
                      required
                    />
                    <span className="input-group-addon" onClick={() => setShowSecurityAnswer(!showSecurityAnswer)} style={{ cursor: 'pointer' }}>
                      <i className={`fa ${showSecurityAnswer ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr style={{ borderTop: '1px solid #ccc' }} />

          {/* ================== CAPTCHA ================== */}
          <div>
            <h4>CAPTCHA</h4>
            <div className="form-horizontal formLabel">
              <div className="form-group">
                <label className="control-label col-sm-4">
                  Enter CAPTCHA as shown below <span className="text-primary">(case sensitive)</span>
                </label>
                <div className="col-sm-4">
                  <input type="text" name="captcha" className="form-control" maxLength="6" value={formData.captcha} onChange={handleChange} required />
                </div>
              </div>
              <div className="form-group">
                <label className="control-label col-sm-4">CAPTCHA</label>
                <div className="col-sm-4">
                  {/* Placeholder for Captcha Image */}
                  <div style={{ display: 'inline-block', verticalAlign: 'middle' }}>
                    <img src="/assets/cuet-mock/images/DisplayCaptchaImg.jpg" alt="Captcha" style={{ height: '34px', borderWidth: '0px' }} />
                  </div>
                  <div style={{ display: 'inline-block', verticalAlign: 'middle', marginLeft: '10px' }}>
                    <img src="/assets/cuet-mock/images/Refresh.png" alt="Refresh" style={{ height: '30px', width: '30px', cursor: 'pointer' }} title="Regenerate CAPTCHA." />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ================== SUBMIT BUTTON ================== */}
          <div className="form-group">
            <div className="col-sm-12 text-center" style={{ marginTop: '20px' }}>
              <button
                type="submit"
                className="btn btn-primary btn-lg"
                onClick={handleSubmit}
                disabled={loading}
                style={{ minWidth: '150px' }}
              >
                {loading ? 'Submitting...' : 'Submit'}
              </button>
            </div>
          </div>

          <br /><br />
        </div>
      </div>
    </div>
  );
};

export default RegistrationPage;